import React from 'react';

import ManageIpList from "./manage-ip-list";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './ManageIP.scss';

const ManageWhiteListIp = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-full flex justify-center items-center campain-table-container container">
        <div className="table-wrapper w-full">
          <div className="campain-title">
            <h2 className="text-center mt-3">Manage WhiteList IP</h2>
          </div>
          <ManageIpList />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ManageWhiteListIp;
